import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { Circle } from "@mui/icons-material";

const mapValueToOptions = (
  value: string | number | string[] | number[],
  options: { label: string; value: string | number }[]
) => {
  if (Array.isArray(value)) {
    return (
      <List
        dense
        sx={{
          py: 0,
          overflowY: "auto",
          maxHeight: "156px",
        }}
      >
        {value
          ?.filter((id) => options.map(({ value }) => value).includes(id))
          .map((id) => (
            <ListItem
              key={id}
              disablePadding
              disableGutters
              sx={{ wordWrap: "break-word" }}
            >
              <ListItemIcon sx={{ minWidth: "13px" }}>
                <Circle sx={{ fontSize: 8 }} />
              </ListItemIcon>
              <ListItemText
                primary={options.find((i) => i.value === id)?.label}
              />
            </ListItem>
          ))}
      </List>
    );
  }

  return options.find((i) => i.value === value)?.label;
};

export default mapValueToOptions;
